







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import { Document } from "../Document.vue";
import _ from "lodash";

@Component({ components: { SimpleText } })
export default class DocumentInsertionCampaign extends Vue {
    @Prop() public document!: Document;

    protected get campaign(): string {
        return _.get(this.document, "insertions.0.campaign", "");
    }

    public static getNeededFields(): string[] {
        return [];
    }
}
